/* tslint:disable */
/* eslint-disable */
export enum OrderState {
  DisbursementsEntered = 'DISBURSEMENTS_ENTERED',
}
